<template>
  <div class="avatar-group">
    <div
      v-for="(item, index) in croppedAvatarsByLength"
      :key="index"
      :style="`z-index: ${index}`"
      class="avatar-group__item"
    >
      <Avatar
        v-if="user"
        :userEnabled="item ? item.enabled : true"
        :tooltipText="item?.username ?? 'Select Owner'"
        :tooltipTheme="'info-tooltip-sm'"
        :src="item?.pictureUrl ?? null"
        :gap="item?.getInitials()"
        :type="type"
        class="avatar-group__item"
        :class="[
          { 'avatar-select__gap avatar is-md': !item },
          { 'is-scale-by-hover': scaleByHover }
        ]"
        bordered
      />
    </div>

    <VDropdown
      v-if="lengthOfHiddenAvatars"
      theme="info-tooltip-sm"
      placement="bottom"
      :triggers="['click']"
      :hideTriggers="['click']"
      :delay="0"
      :autoHide="true"
      class="avatar-group__item"
      :style="`z-index: ${numberOfVisibleUsers + 1}`"
      popperClass="epic-popper"
    >
      <div
        class="avatar is-md is-bordered avatar__length"
        :class="[{ 'is-scale-by-hover': scaleByHover }]"
        @click.stop
      >
        +{{ lengthOfHiddenAvatars }}
      </div>

      <template #popper>
        <div
          v-for="(item, index) in hiddenAvatarsList"
          :key="index"
          class="avatar-icon-tooltip-hidden"
        >
          <Avatar
            :userEnabled="item ? item.enabled : true"
            :src="getHiddenAvatarPictureUrl(item)"
            :gap="item?.getInitials()"
            :type="type"
            size="sm"
            class="popper-menu__img"
            bordered
          />
          {{ getHiddenAvatarName(item) }}
        </div>
      </template>
    </VDropdown>
    <div v-if="!croppedAvatarsByLength.length">
      <Avatar
        :src="null"
        tooltipText="Select Owner"
        :type="type"
        bordered
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import Avatar from "@/components/Avatar/index.vue"

import { User } from "@/models"

import type { PropType } from "vue"

const props = defineProps({
  numberOfVisibleUsers: {
    type: Number,
    default: 3
  },
  type: {
    type: String,
    required: true
  },
  avatars: {
    type: Array as PropType<User[]>,
    default: () => []
  },
  user: {
    type: Boolean,
    default: false
  },
  scaleByHover: {
    type: Boolean,
    default: true
  }
})

const croppedAvatarsByLength = computed(() => {
  if (props.avatars.length <= props.numberOfVisibleUsers) return props.avatars
  return props.avatars.slice(0, props.numberOfVisibleUsers - 1)
})

const lengthOfHiddenAvatars = computed(
  () => props.avatars.length - croppedAvatarsByLength.value.length
)

const hiddenAvatarsList = computed(() => props.avatars.slice(props.numberOfVisibleUsers - 1))

function getHiddenAvatarName(item) {
  return item?.username || ""
}

function getHiddenAvatarPictureUrl(item) {
  return item?.pictureUrl ?? null
}
</script>
